import React from 'react'
import { Box, Button, Modal, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ResetUserResponse, ResetUserResponseError } from './state/actions'

interface NewModalProps {
  open: boolean
  handleClose: () => void
  resetUserResponse: ResetUserResponse | ResetUserResponseError
}

const ResetUserModal: React.FC<NewModalProps> = ({ open, handleClose, resetUserResponse }) => {
  const { t } = useTranslation()
  let message = ''
  function hasData(obj: any): obj is { Data: { Status: string; Message: string } } {
    return obj && typeof obj === 'object' && 'Data' in obj && obj.Data !== undefined
  }

  const isSuccess = hasData(resetUserResponse) && resetUserResponse.Data.Status === 'Success'
  const isError = 'Error' in resetUserResponse && resetUserResponse.Error

  if (isSuccess && hasData(resetUserResponse)) {
    message = t(resetUserResponse.Data.Message)
  }
  if (isError && hasData(resetUserResponse)) {
    message = t(resetUserResponse.Data.Message)
  }
  const actions = [{ label: t('AppLabels.ok'), onClick: handleClose, className: 'button contained' }]
  return (
    <Modal open={open} onClose={handleClose} data-testid='reset_modal'>
      <Box className='modal-box'>
        <Typography className='title'>{hasData(resetUserResponse) ? t(resetUserResponse.Data.Status) : ''}</Typography>
        <Typography className={isSuccess ? 'content' : 'highlight'}>{message}</Typography>
        <Box className='actions'>
          {actions.map((action, index) => (
            <Button key={index} className={action.className} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </Box>
      </Box>
    </Modal>
  )
}

export default ResetUserModal
